import {ChangeDetectionStrategy, Component, inject, InjectionToken} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export type ConfirmationDialogInput = {
    readonly title: string;
    readonly message: string;
    readonly btnOkText: string;
    readonly btnCancelText: string;
    /** Show the cancel button next to the confirm button. Defaults to true. */
    readonly showCancel?: boolean;
    /** Highlight the dialog as a warning (e.g. destructive confirmations). Off by default. */
    readonly warning?: boolean;
    /** Bootstrap class for the cancel button, so an app can keep its legacy look. */
    readonly cancelButtonClass?: string;
    /** When set, the confirm button stays disabled until the user ticks this checkbox. */
    readonly checkboxLabel?: string;
};

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
    static readonly inputToken = new InjectionToken<ConfirmationDialogInput>(
        'ConfirmationDialogComponent.input',
    );

    private readonly input = inject(ConfirmationDialogComponent.inputToken);
    private readonly activeModal = inject(NgbActiveModal);

    protected readonly title = this.input.title;
    protected readonly message = this.input.message;
    protected readonly btnOkText = this.input.btnOkText;
    protected readonly btnCancelText = this.input.btnCancelText;
    protected readonly showCancel = this.input.showCancel ?? true;
    protected readonly warning = this.input.warning ?? false;
    protected readonly cancelButtonClass = this.input.cancelButtonClass ?? 'btn-outline-primary';
    protected readonly checkboxLabel = this.input.checkboxLabel ?? '';

    protected checked = false;

    protected toggleChecked(): void {
        this.checked = !this.checked;
    }

    decline(): void {
        this.activeModal.close(false);
    }

    accept(): void {
        this.activeModal.close(true);
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
